module.exports = __webpack_public_path__ + "static/img/SCRM01.a80de6ab.png";